module.exports = __webpack_public_path__ + "img/mail-05.1ceb5c05.svg";